import { IEvent } from "@lib/store/src/calendar";
import styles from "../styles.css";
import { getOptionTemplateByType } from "../modal.templates";
import { createTimePickerSelect } from "../modal.helpers";
import i18next from "i18next";

export const getEditEventExceptionTemplate = () => `
   <style>
        ${styles}
    </style>
    <div class="modal-week-container">
        <div class="input-container" slot="children">

            <div class="form-row">
                <div class="form-block">    
                    <p class="form-label">${i18next.t($ => $.scheduleBacnet.exceptionFieldPriority)}</p>
                    <fw-input type="number" min="1" max="16" value="1" id="priority"></fw-input>
                </div>          
            </div>

            <div class="form-row form-title justify-between">
                <p>${i18next.t($ => $.scheduleBacnet.event)}</p>
            </div>

            <div class="grid-container grid-container_single">
                <div class="grid-header">
                    <div>${i18next.t($ => $.scheduleBacnet.time)}</div>
                    <div>${i18next.t($ => $.scheduleBacnet.dataType)}</div>
                    <div>${i18next.t($ => $.scheduleBacnet.value)}</div>
                    <div></div> <!-- Пустой элемент для крестика удаления -->
                </div>
                <div class="grid-body" id="events">
                    
                </div>
            </div>  

            <div class="form-row">
                <div class="form-block">    
                    <p class="form-label">${i18next.t($ => $.scheduleBacnet.period)}</p> 
                    <select
                        id="select-period"
                        placeholder="${i18next.t($ => $.scheduleBacnet.choosePeriod)}"
                        value="date"
                    >
                    </select>

                    <div id="period-form"></div>

                </div>          
            </div>
        </div>
        
        <div class="modal-buttons-wrap">
            <fw-tooltip id="tooltip" placement="bottom" trigger="hover" content="">
                <fw-button id="submit" color="primary">${i18next.t($ => $.apply)}</fw-button>
            </fw-tooltip>
            <fw-button id="reset" color="secondary">${i18next.t($ => $.cancel)}</fw-button>
        </div>
    </div>
`;

export const getEditEventTemplate = (event: IEvent) => `
    ${createTimePickerSelect( 
      `${event?.time?.hours}:${event?.time?.minutes}:${event?.time?.seconds || "00"}`
    )}
    <select
        id="select-type"
        placeholder="${i18next.t($ => $.scheduleBacnet.chooseDataType)}"
        value="${event?.dataType}"
    >
    </select>
    <div id="block-value">
        ${getOptionTemplateByType(event?.dataType, event?.value)}
    </div>
    <div class="delete-btn">✕</div>
`;
